module.exports = __webpack_public_path__ + "img/bg_2.57a4aee3.png";